import type { Optional } from '@festina-life/core'

import type { ConfigurationTemplateFunctionValue } from '../../types/templateModel'
import { FPlusDiff } from '../fplusDiff/FPlusDiff'

type Props = {
  title: string
  current: Optional<ConfigurationTemplateFunctionValue>
  compare: Optional<ConfigurationTemplateFunctionValue>
}

/**
 * A function's body is an F-plus expression like any other, and is read as one:
 * as a diff, rather than as two whole bodies to compare by eye.
 */
export const ConfigurationTemplateFunctionValueExpresssionDiff = ({
  current,
  compare,
  title,
}: Props) => (
  <FPlusDiff
    title={title}
    compare={compare?.function?.fplusSource}
    current={current?.function?.fplusSource}
  />
)
